import { ResponsiveArray } from "@chakra-ui/react";

export const RESPONSIVE_STACK_DIRECTION = ["column", "column", "row"] as ResponsiveArray<any>;